import { defineComponent as _defineComponent } from 'vue'
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  items?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductContentBannerPoints',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isBiggerSm } = useBreakpoint('sm');

const getIcon = (item: any) =>
  getAssetUrl(isBiggerSm.value ? item.icon?.desktop : item.icon?.mobile) ??
  undefined;

return { __sfc: true,getAssetUrl, isBiggerSm, getIcon }
}

})